import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModBoss } from '@vp/mod-father';
import { OrderDetailsContext } from '../../components/contexts/OrderDetailsContext';
import { PageModsContext } from '../../components/contexts/PageModsContext';
import {
  commonVpDependenciesV1,
  lineItemGroupInfoV1,
  orderInfoV1,
  orderInfoV2,
  orderItemGroupItemsInfoV1,
  profileInfoV1,
} from '../uxModsContracts';
import { modfatherTracker as hostTracker } from '../../apis/trackingApi';
import useShopperProfile from '../../hooks/useShopperProfile';

/**
 * This wrapper allows this application to inject UX mods into the children of this component.
 * It is meant for use only on lineItem group objects
 */
const DetailsItemGroupUxModWrapper = ({ groupId, children }) => {
  const orderDetailsContext = useContext(OrderDetailsContext);

  const { activeItemGroupLevelPageUxMods: itemGroupPageMods } =
    useContext(PageModsContext);

  const profile = useShopperProfile();
  const { order, vistacartTenantName } = orderDetailsContext;

  const orderItemGroups = order?.itemGroups || [];
  const itemGroupData = orderItemGroups.find(
    group => group.groupId === groupId
  );

  const itemGroupAttachedUxModSpecs = itemGroupData?.customOrderData?.ux || [];

  const environmentData = {
    orderInfoV1: orderInfoV1(order, vistacartTenantName),
    orderInfoV2: orderInfoV2(order, vistacartTenantName),
    profileInfoV1: profileInfoV1(
      order.emailAddress || profile?.email || '',
      order.shippingAddress?.phone || ''
    ),
    lineItemGroupInfoV1: lineItemGroupInfoV1(order, groupId),
    orderItemGroupItemsInfoV1: orderItemGroupItemsInfoV1(order, groupId),
    commonVpDependenciesV1,
  };

  return (
    <ModBoss
      mods={[
        ...(itemGroupPageMods || []),
        ...(itemGroupAttachedUxModSpecs || []),
      ]}
      environmentData={environmentData}
      contextKey={groupId}
      hostTracker={hostTracker}
    >
      {children}
    </ModBoss>
  );
};

DetailsItemGroupUxModWrapper.propTypes = {
  groupId: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default DetailsItemGroupUxModWrapper;
